import { memo } from "react";
import { Avatar, Button, Card, Col, Input, Row, Typography } from "antd";
import { LineOutlined, SendOutlined } from "@ant-design/icons";
import ReviewCommentsAndActionItemsView from "../partials/ReviewCommentsAndActionItemsView";


export function CommentsActionsTabComponent({
  canManageReviewItems,
  selectedProjectId,
  commentText,
  actionItemsText,
  onCommentTextChange,
  onActionItemsTextChange,
  onAddComment,
  onAddAction,
  comments,
  actions,
  editingCommentId,
  editingCommentText,
  onEditComment,
  onEditCommentTextChange,
  onSaveCommentEdit,
  onCancelCommentEdit,
  onDeleteComment,
  editingRowId,
  editingRowData,
  onEditAction,
  onUpdateEditingRowField,
  onSaveActionEdit,
  onCancelActionEdit,
  onDeleteAction,
}) {
  return (
    <>
      {canManageReviewItems && (
        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
          <Col xs={24} lg={12}>
            <Card
              style={{
                borderRadius: 14,
                border: "1px solid #f0f0f0",
              }}
              styles={{ body: { padding: 16 } }}
              title={
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontWeight: 600, fontSize: 14 }}>Add Comment</span>
                </div>
              }
            >
              <div
                style={{
                  padding: 12,
                  backgroundColor: "#fafafa",
                  borderRadius: 10,
                  border: "1px solid #f0f0f0",
                }}
              >
                <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                  <Avatar style={{ background: "#1677ff", flexShrink: 0 }}>Y</Avatar>

                  <div style={{ flex: 1 }}>
                    <Input.TextArea
                      placeholder="Enter review comments during discussion..."
                      value={commentText}
                      onChange={(e) => onCommentTextChange(e.target.value)}
                      onPressEnter={(e) => {
                        if (e.ctrlKey || e.metaKey) {
                          onAddComment();
                        }
                      }}
                      rows={3}
                      style={{
                        fontSize: 13,
                        borderRadius: 8,
                        border: "1px solid #d9d9d9",
                      }}
                      autoFocus
                    />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 8,
                        gap: 8,
                      }}
                    >
                      <Typography.Text
                        type="secondary"
                        style={{
                          fontSize: 11,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <LineOutlined style={{ marginRight: 4 }} />
                        Multi-line comments are added as separate items
                      </Typography.Text>

                      <Button
                        type="primary"
                        size="small"
                        icon={<SendOutlined />}
                        onClick={onAddComment}
                        style={{
                          background: "linear-gradient(135deg,#1677ff,#4096ff)",
                          border: "none",
                          flexShrink: 0,
                        }}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card
              style={{
                borderRadius: 14,
                border: "1px solid #f0f0f0",
              }}
              styles={{ body: { padding: 16 } }}
              title={
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontWeight: 600, fontSize: 14 }}>Add Action</span>
                </div>
              }
            >
              <div
                style={{
                  padding: 12,
                  backgroundColor: "#fafafa",
                  borderRadius: 10,
                  border: "1px solid #f0f0f0",
                }}
              >
                <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                  <Avatar style={{ background: "#FABB02", flexShrink: 0 }}>A</Avatar>

                  <div style={{ flex: 1 }}>
                    <Input.TextArea
                      placeholder="Enter action items during discussion..."
                      value={actionItemsText}
                      onChange={(e) => onActionItemsTextChange(e.target.value)}
                      onPressEnter={(e) => {
                        if (e.ctrlKey || e.metaKey) {
                          onAddAction();
                        }
                      }}
                      rows={3}
                      style={{
                        fontSize: 13,
                        borderRadius: 8,
                        border: "1px solid #d9d9d9",
                      }}
                      autoFocus
                    />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 8,
                        gap: 8,
                      }}
                    >
                      <Typography.Text
                        type="secondary"
                        style={{
                          fontSize: 11,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <LineOutlined style={{ marginRight: 4 }} />
                        Multi-line actions are added as separate items
                      </Typography.Text>

                      <Button
                        type="primary"
                        size="small"
                        icon={<SendOutlined />}
                        onClick={onAddAction}
                        style={{
                          background: "linear-gradient(135deg,#1677ff,#4096ff)",
                          border: "none",
                          flexShrink: 0,
                        }}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      )}

      <ReviewCommentsAndActionItemsView
        projectId={selectedProjectId}
        comments={comments}
        actions={actions}
        readOnly={!canManageReviewItems}
        editingCommentId={editingCommentId}
        editingCommentText={editingCommentText}
        onEditComment={onEditComment}
        onEditCommentTextChange={onEditCommentTextChange}
        onSaveCommentEdit={onSaveCommentEdit}
        onCancelCommentEdit={onCancelCommentEdit}
        onDeleteComment={onDeleteComment}
        editingRowId={editingRowId}
        editingRowData={editingRowData}
        onEditAction={onEditAction}
        onUpdateEditingRowField={onUpdateEditingRowField}
        onSaveActionEdit={onSaveActionEdit}
        onCancelActionEdit={onCancelActionEdit}
        onDeleteAction={onDeleteAction}
      />
    </>
  );
}

export const CommentsActionsTab = memo(CommentsActionsTabComponent);
